// extracted by mini-css-extract-plugin
export default {"sms-content-bubble-wrapper":"f9uCxJe6wS0hi7bWvwZ1ZA==","sms-content-bubble-card":"ys7g7jXbCJBzohvSBThoaQ==","corner-icon":"Epks5FIB-y2aBby7zRl4dw=="};